/**
 * @fileoverview - Adds or updates package protection in cart.
 * Note: Does not support multiple currencies, only works well with
 * USD.
 */

/**
 * Adds free productY to cart if productX is in cart.
 * Note: Logic is currently set to add 1 free nail glue for every C-curve
 * product type purchase.
 */
function buyXgetY() {
  return new Promise(async (resolve, reject) => {
    // Get cart items from current cart.
    var cartContents = await fetch(window.theme.localeRootUrl + '/cart.js')
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    var cCurvesInCart = 0,
      glueInCart = 0;
    for (var item of cartContents.items) {
      // Check if a C-curve exists in cart.
      if (
        item.product_type === 'C-Curve' &&
        !Object.keys(item.properties).length
      ) {
        cCurvesInCart += item.quantity;
      }

      // Check if glue is already in cart.
      if (item.id === 39986663719048 && !Object.keys(item.properties).length) {
        glueInCart += item.quantity;
      }
    }

    var glueToAdd = cCurvesInCart - glueInCart;
    if (glueToAdd <= 0) {
      resolve();
    } else {
      await fetch(window.theme.localeRootUrl + '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: 39986663719048, // Nail glue variant id.
              quantity: glueToAdd,
            },
          ],
        }),
      }).then(function (response) {
        if (response.ok) {
          resolve();
        } else {
          reject(`Failed to add free glue`);
        }
      });
    }
  });
}

/**
 * Adds or removes free gift item based on cart threshold.
 * Orders over $200 (excluding package protection) get a free item.
 * Ensures only ONE free gift exists in cart (prevents duplicates).
 * @returns {Promise} - Resolves when check is complete.
 */
// var _freeItemCheckerPromise = null;
//
// async function freeItemChecker() {
//   if (_freeItemCheckerPromise) {
//     await _freeItemCheckerPromise;
//   }
//   _freeItemCheckerPromise = _executeFreeItemCheck();
//   try {
//     await _freeItemCheckerPromise;
//   } finally {
//     _freeItemCheckerPromise = null;
//   }
// }
//
// async function _executeFreeItemCheck() {
//   var freeItemVariantId = 44508344942728; // UPDATE: Set to current promo item
//   var thresholdCents = 20000; // $200.00
//
//   if (sessionStorage.getItem('removed_free_gift')) {
//     return;
//   }
//
//   var cartContents = await fetch(window.theme.localeRootUrl + '/cart.js')
//     .then((response) => response.json());
//
//   var cartTotal = cartContents.total_price;
//   var freeItems = [];
//
//   for (var item of cartContents.items) {
//     if (item.handle === 'kiara-sky-package-protection') {
//       cartTotal -= item.price * item.quantity;
//     }
//     if (
//       item.id === freeItemVariantId &&
//       item.properties &&
//       item.properties._free_gift
//     ) {
//       freeItems.push({ key: item.key, quantity: item.quantity });
//       cartTotal -= item.price * item.quantity;
//     }
//   }
//
//   var qualifies = cartTotal >= thresholdCents;
//   var hasFreeItem = freeItems.length > 0;
//
//   if (qualifies && !hasFreeItem) {
//     await fetch(window.theme.localeRootUrl + '/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         items: [{
//           id: freeItemVariantId,
//           quantity: 1,
//           properties: { _free_gift: 'spend-200-promo' },
//         }],
//       }),
//     });
//     return;
//   }
//
//   if (hasFreeItem) {
//     var updates = {};
//     var needsUpdate = false;
//     for (var i = 1; i < freeItems.length; i++) {
//       updates[freeItems[i].key] = 0;
//       needsUpdate = true;
//     }
//     var targetQty = qualifies ? 1 : 0;
//     if (freeItems[0].quantity !== targetQty) {
//       updates[freeItems[0].key] = targetQty;
//       needsUpdate = true;
//     }
//     if (needsUpdate) {
//       await fetch(window.theme.localeRootUrl + '/cart/update.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest',
//         },
//         body: JSON.stringify({ updates: updates }),
//       });
//     }
//   }
// }

/**
 * Package protection variant tiers based on cart total.
 * Each tier has a variant ID and maximum cart value in cents.
 */
var insuranceVariants = [
  { id: 39553534853256, maxCents: 14998 },    // $0.01 - $149.98
  { id: 39553534886024, maxCents: 24998 },    // $149.99 - $249.98
  { id: 39553534918792, maxCents: 34998 },    // $249.99 - $349.98
  { id: 39553534951560, maxCents: 44998 },    // $349.99 - $449.98
  { id: 39553534984328, maxCents: 60100 },    // $449.99 - $601.00
  { id: 39553535017096, maxCents: Infinity }, // $601.01+
];

/**
 * Returns the correct insurance variant ID for a given cart total.
 * @param {number} cartTotalCents - Cart total in cents (excluding insurance).
 * @returns {number|null} - Variant ID or null if no insurance needed.
 */
function getCorrectInsuranceVariant(cartTotalCents) {
  if (cartTotalCents < 1) return null;
  return insuranceVariants.find(function (tier) {
    return cartTotalCents <= tier.maxCents;
  }).id;
}

/**
 * Promise-based queue to prevent concurrent insurance checks.
 */
var _insuranceCheckerPromise = null;

/**
 * Adds or updates package protection in cart. Ensures only ONE package
 * protection item exists at the correct tier for the cart total.
 * Uses a queue mechanism to prevent race conditions from concurrent calls.
 * @returns {Promise} - Resolves when check is complete.
 */
async function insuranceChecker() {
  // Queue mechanism - if already running, wait for it then run again
  if (_insuranceCheckerPromise) {
    await _insuranceCheckerPromise;
  }

  _insuranceCheckerPromise = _executeInsuranceCheck();

  try {
    await _insuranceCheckerPromise;
  } finally {
    _insuranceCheckerPromise = null;
  }
}

/**
 * Executes the insurance check logic. Called by insuranceChecker() wrapper.
 */
async function _executeInsuranceCheck() {
  // Note: Uncomment to enable free gift for orders over $200
  // await freeItemChecker();

  // Note: Uncomment to enable buy X get Y logic
  // await buyXgetY();

  // Skip if user has opted out of insurance this session
  if (sessionStorage.getItem('removed_insurance')) {
    return;
  }

  // Fetch current cart
  var cart = await fetch(window.theme.localeRootUrl + '/cart.js').then(
    function (response) {
      return response.json();
    }
  );

  // Collect ALL insurance items and calculate adjusted cart total
  var insuranceItems = [];
  var cartTotal = cart.total_price;

  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    if (item.handle === 'kiara-sky-package-protection') {
      insuranceItems.push({
        key: item.key,
        id: item.id,
        quantity: item.quantity,
      });
      // Exclude insurance price from cart total calculation
      cartTotal -= item.price * item.quantity;
    }
  }

  // Determine the correct variant for this cart total
  var correctVariantId = getCorrectInsuranceVariant(cartTotal);

  // Find if correct variant already exists with qty=1
  var correctItemIndex = -1;
  for (var j = 0; j < insuranceItems.length; j++) {
    if (
      insuranceItems[j].id === correctVariantId &&
      insuranceItems[j].quantity === 1
    ) {
      correctItemIndex = j;
      break;
    }
  }

  // Build updates object for removing duplicates/wrong variants
  var updates = {};
  var needsUpdate = false;

  for (var k = 0; k < insuranceItems.length; k++) {
    if (k === correctItemIndex) {
      // Keep this one - it's the correct variant with correct quantity
      continue;
    }
    // Remove all others (duplicates, wrong tiers, wrong quantities)
    updates[insuranceItems[k].key] = 0;
    needsUpdate = true;
  }

  // Case 1: Need to add correct variant (doesn't exist yet)
  if (correctVariantId && correctItemIndex === -1) {
    // First remove any duplicates/wrong variants
    if (needsUpdate) {
      await fetch(window.theme.localeRootUrl + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
    }
    // Then add the correct variant
    await fetch(window.theme.localeRootUrl + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: correctVariantId, quantity: 1 }],
      }),
    });
    return;
  }

  // Case 2: Just need to remove duplicates/wrong variants
  if (needsUpdate) {
    await fetch(window.theme.localeRootUrl + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
  }
}
